import { createContext } from 'react'
import type mapboxgl from 'mapbox-gl'
import { MapType } from '../map/mapContext'

export const MapContext = createContext<{
  map: mapboxgl.Map | null
  mapType: MapType | undefined
  is3D: boolean
} | null>(null)
